

export const getTranslationIdForTagList = (tags) => {
    if (tags && tags.length) {
        if (tags.indexOf('HELP_PAGE_COMMON') > -1) {
            return "help.tag_type_common";
        }

        if (tags.indexOf('HELP_PAGE_CADASTRAL_INFO') > -1) {
            return "help.tag_type_cadastral";
        }

        if (tags.indexOf('HELP_PAGE_EDITING') > -1) {
            return "help.tag_type_editing";
        }
    }

    return '';
}